export default __webpack_public_path__ + "static/media/tool-item-h5-bg3.fdbb7fb1.png";